import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyService } from '../services/currency.service';

/**
 * Formats a primary-currency price for display (number only, no symbol).
 * Mirrors iOS removeTrailingZeros: "150.00" -> "150", "0.03" -> "0.03".
 * The currency symbol is rendered separately in the templates.
 */
@Pipe({
    name: 'price',
    standalone: false
})
export class PricePipe implements PipeTransform {
  constructor(private currencyService: CurrencyService) {}

  transform(value: string | number | null | undefined): string {
    if (value === null || value === undefined || value === '') {
      return '';
    }
    return this.currencyService.formatPrice(value);
  }
}
